export default __webpack_public_path__ + "09cd0a4fa0694f1da704ce38940d9043.png";